/**
 * ProjectTrackItem Component
 */

import { getDefaultTrackAsset, getResponsiveTrackThumbnail, getTrackPriceElement } from '../../../../utils/track';
import './project-track-item.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { SortableElement } from 'react-sortable-hoc';

import Card from '../../../molecules/media/Card';
import { ITrackItemProps } from '../form';

export interface IProjectTrackItemProps extends ITrackItemProps {
  title: string;
  cardSize: 'small' | 'medium';
  license: ILicenseUsage[];
  projectId: string;
  trackResult: GQL.ITrackSearchResult | undefined;
  trackEdge: GQL.IProjectTrackEdge | undefined;
  remove(): void;
  onSaveLicense(usages: ILicenseUsage[]): void;
}

const classes = new BEM('project-track');

export const ProjectTrackItem = SortableElement<IProjectTrackItemProps>((props) => {
  const {
    cardSize,
    license,
    onSaveLicense,
    projectId,
    remove,
    title,
    trackEdge,
    trackResult,
  } = props;

  const {
    artist,
    assets,
  } = trackResult!;

  const options: Array<CardOption | ICardOption> = [
    'FindSimilar',
    'Download',
    {
      option: 'RemoveFromProject',
      listener: remove,
    },
    'PriceElement',
  ];

  const trackId = getDefaultTrackAsset(assets!, trackEdge!.version).id;
  const thumbnail = getResponsiveTrackThumbnail(trackResult!);
  const PriceElement = getTrackPriceElement(
    trackResult!, {
      buttonProps: {
        variant: 'pill',
        size: 'small',
        withShadow: true,
      },
      addToCartButtonProps: {
        usages: license,
      },
      licenseBuilderButtonProps: {
        onSaveLicense,
        scope: {
          type: 'Project',
          id: projectId,
        },
      },
    },
  );

  return (
    <div {...classes()}>
      <Card
        actionSource="project_list"
        backgroundColor="bw3"
        trackId={trackId}
        title={title!}
        subtitle={artist!.name!}
        image={thumbnail}
        license={license}
        PriceElement={PriceElement}
        trackResult={trackResult}
        size={cardSize}
        options={options}
        {...classes('card') }
      />
    </div>
  );
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Projects/projectView/ProjectTrackItem.tsx